import _ from "lodash";
import NetworkedGroup from "users/networking/groups/networked-group";

export default class UpdateNetworkedGroupApiRequest {
  public payload: { op: string; path: string; value: unknown }[] | null = null;
  public readonly expectedVersion: string;

  public constructor(
    originalGroup: NetworkedGroup,
    updatedGroup: NetworkedGroup
  ) {
    this.expectedVersion = originalGroup.version;
    this.payload = [];

    // Simple value comparisons
    this.compareAndPush(updatedGroup, originalGroup, "name");
    this.compareAndPush(updatedGroup, originalGroup, "description");

    // Deep equality comparisons
    this.deepCompareAndPush(updatedGroup, originalGroup, "memberUserIds");
  }

  public deepCompareAndPush(updatedGroup: NetworkedGroup, originalGroup: NetworkedGroup, key: keyof NetworkedGroup) {
    const updatedValue = updatedGroup[key];
    const originalValue = originalGroup[key];

    if (!_.isEqual(updatedValue, originalValue)) {
      this.payload?.push({
        op: "replace",
        path: `/${key}`,
        value: updatedValue
      });
    }
  }

  public compareAndPush(updatedGroup: NetworkedGroup, originalGroup: NetworkedGroup, key: keyof NetworkedGroup) {
    const updatedValue = updatedGroup[key];
    const originalValue = originalGroup[key];

    if (updatedValue !== originalValue) {
      this.payload?.push({
        op: "replace",
        path: `/${key}`,
        value: updatedValue
      });
    }
  }
}
